import React from 'react';
import { Stack, Typography } from '@mui/material';
import { DocumentFile } from '@peerless/data-access/strapi';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icons } from '@peerless/ui-assets/icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface Props {
  file: DocumentFile;
}

export const Document: React.FC<Props> = ({ file }) => {
  const isDWG = file.ext?.toLowerCase().replace('.', '') === 'dwg';

  return (
    <a
      href={file.url}
      download
      target="_blank"
      rel="noreferrer"
      style={{ textDecoration: 'none', color: 'black' }}
    >
      <Stack
        spacing={1}
        alignItems="center"
        sx={{
          '.fa-lg': { fontSize: '4rem', color: isDWG ? 'success.main' : 'primary.main' },
        }}
      >
        <FontAwesomeIcon icon={getIconFromExtension(file.ext)} size="lg" />
        <Typography textAlign={'center'}>{file.name}</Typography>
      </Stack>
    </a>
  );
};

const getIconFromExtension = (ext: string | undefined): IconProp => {
  // Normalize file extension names by removing dots and lowercasing.
  switch (ext?.toLowerCase().replace('.', '')) {
    case 'pdf':
      return icons.filePdf;
    case 'dwg':
      return icons.fileCad;
    default:
      return icons.file;
  }
};
